<template>
    <div class="container">
        <div class="content">

<!-- 头 -->
            <!-- <div class="top">
                <img src="../../assets/five/dx.png">
                <p>该二维码可用于现场扫码出票</p>
                <img src="../../assets/five/dx.png">
            </div> -->

<!-- 二维码 -->
            <!-- <div class="code"><img src="../../assets/five/ewm.png"></div> -->
            <!-- <div class="code"> -->
                <!-- <vue-qr :logoSrc="imgURL" :text="sucResult.base64_img + ''" :size="250"></vue-qr> -->
                <!-- <img :src="`data:image/jpeg;base64,${base64_img}`"> -->
            <!-- </div> -->

<!-- 信息 -->
            <div class="middle">
                <p><span>预约号票：</span><span>{{sucResult.reservNo}}</span></p>
                <p><span>预约手机：</span><span>{{sucResult.phone}}</span></p>
                <p><span>办理业务：</span><span>{{sucResult.bussName}}</span></p>
                <p v-if="sucResult.itemName"><span>办理事项：</span><span>{{sucResult.itemName}}</span></p>
                <p><span>预约时间：</span><span>{{sucResult.reservDate+' '+sucResult.startTime+'-'+sucResult.endTime}}</span></p>
            </div>

            <div class="foot">
<!-- 取消按钮 -->
                <div @click="cancel(sucResult)" v-if="tocancel"><span>取消预约</span></div>
<!-- 关闭按钮 -->
                <div @click="close"><span>关闭弹窗</span></div>
            </div>
        </div>
    </div>
</template>


<script>

import { Dialog, Toast} from 'vant'      // 弹窗
import { getMsg } from '../../tools/get'  // 取消预约
import vueQr from 'vue-qr' // 二维码

export default {
    props: [ "sucResult", "base64_img", "job", "tocancel" ],
    inject:['reload'],
    components:{ vueQr },
    data(){
        return {
            datas: this.sucResult,
            Flag: false
        }
    },
    // created(){ this.updateQR(); },
    // mounted(){ this.updateQR(); },
    methods:{

// 取消方法
        cancel(data){
            console.log(data)

            var url='';
            var obj={
                        "cmd":"yyqx",
                        "reservNo": data.reservNo
                    }
            console.log(obj);

            Dialog.confirm({
                title:'提示',
                message:'确认取消预约吗？'
            }).then(()=>{

                getMsg(url, obj).then(result=>{

                    console.log('接到 - 响应')
                    console.log(result)

                    if(result.status == 200){
                        if(result.data.result == 0){

                            this.$emit("cancelSuc", false)
                            Toast(result.data.errdesc)
                        }
                        else if( result.data.status == 301){ Dialog.alert({ title: '标题', message: result.data.errdesc}).then(() => { this.$emit("cancelSuc",false); }); }
                        else if( result.data.status == 302){ Dialog.alert({ title: '标题', message: result.data.errdesc}).then(() => { this.$emit("cancelSuc",false); }); }
                        else if( result.data.status == 303){ Dialog.alert({ title: '标题', message: result.data.errdesc}).then(() => { this.$emit("cancelSuc",false); }); }
                        else if( result.data.status == 305){ Dialog.alert({ title: '标题', message: result.data.errdesc}).then(() => { this.$emit("cancelSuc",false); }); }
                        else if( result.data.status == 304){ Dialog.alert({ title: '标题', message: result.data.errdesc}).then(() => { this.$emit("cancelSuc",false); }); }
                        else if( result.data.status == 306){ Dialog.alert({ title: '标题', message: result.data.errdesc}).then(() => { this.$emit("cancelSuc",false); }); }
                        else if( result.data.status == 307){ Dialog.alert({ title: '标题', message: result.data.errdesc}).then(() => { this.$emit("cancelSuc",false); }); }
                        else if( result.data.status == 308){ Dialog.alert({ title: '标题', message: result.data.errdesc}).then(() => { this.$emit("cancelSuc",false); }); }
                        else if( result.data.status == 309){ Dialog.alert({ title: '标题', message: result.data.errdesc}).then(() => { this.$emit("cancelSuc",false); }); }
                        // else{ Dialog.confirm({ title: '标题', message: result.data.errdesc}).then(() => {}).catch((err) => { console.log(err)}); }
                        else{ Dialog.alert({ title: '标题', message: result.data.errdesc}).then(() => { this.$emit("cancelSuc", false); }) }
                    }
                    // else{ Dialog.confirm({ title: '标题', message: `${result.statusText}，请退出，重新登录`}).then(() => {}).catch((err) => { console.log(err)}); }
                }).catch(err => {console.log(err)})
            }).catch( ()=>{console.log("取消预约") })
        },

// 关闭对话框
        close(){
           console.log('关闭对话框');
            this.bus.$emit('closeNew', false);
            this.reload()
        }
    }
}
</script>

<style scoped>
    *{
        color: #666;
        font-family: Microsoft YaHei;
    }

    input::placeholder{
        color: #aaa;
    }

    .container{
        position: fixed;
        top:0;
        right:0;
        bottom: 0;
        left: 0;
        z-index: 9;
        background:rgba(15, 15, 15, 0.6);
        display: flex;
    }

    .content{
        width: 270.5px;
        height: 200px;
        position: absolute;
        left: 50%;
        margin-left: -135px;
        top: 60%;
        margin-top: -200px;
        background: url(../../assets/five/tc.png) no-repeat;
        background-size: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        border-radius: 5px;
    }


/* 1. 标题 */
    .top{
        width:86%;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        }

    .top>img{
        width:25px;
        }

    .top>p{
        font-size: 14px;
        color: #999;
        }

/* 2. 二维码 */
    .code{
        width: 161px;
        height: 161px;
        margin-top: 10px;
        }
    .code>img{
        width: 161px;
        height: 161px;
        display: block;
        }

/* 3. 预约信息 */
    .middle{
        margin-top: 20px;
        }

    .middle span{
        font-size: 14px;
        color: #999;
        line-height: 22px;
        }

/* 4. 取消预约 */
    .foot{
        width: 270px;
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .foot>div{
        width: 50%;
        height: 36px;
        border-radius: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .foot>div>span{
        text-align: center;
        width: 100px;
        height: 36px;
        border-radius: 18px;
        background-image: linear-gradient(to bottom, #0984e4, #15b8f2);
        line-height: 36px;
        font-size: 16px;
        color: #FFFFFF;
    }

/* 5. 关闭按钮 */
</style>
